
// import React from "react";
// import "./MessageModal.css"; // CSS for the modal

// const MessageModal = ({ isOpen, onClose, message }) => {
//   if (!isOpen) return null;

//   // Helper function to check if the file is an image
//   const isImageFile = (fileName) => {
//     return /\.(jpg|jpeg|png|gif)$/i.test(fileName);
//   };

//   return (
//     <div className="modal-overlay">
//       <div className="modal-content">
//         {/* Close Button */}
//         <button className="close-button" onClick={onClose}>
//           &times;
//         </button>
//         <h2>Message Details</h2>
//         <div className="modal-message-info">
//           <p>
//             <strong>To:</strong> {message.receiver}
//           </p>
//           <p>
//             <strong>From:</strong> {message.sender}
//           </p>
//           <p>
//             <strong>Subject:</strong> {message.subject}
//           </p>
//           <p>
//             <strong>Message:</strong> {message.message}
//           </p>
//           <p>
//             <strong>Time:</strong> {new Date(message.createdAt).toLocaleString()}
//           </p>
//         </div>

//         {/* Display Attachments if available */}
//         {message.files && message.files.length > 0 && (
//           <div className="modal-attachments">
//             <strong>Attachments:</strong>
//             <div className="attachment-links">
//               {message.files.map((file, index) => (
//                 <div key={index} className="attachment-item">
//                   {isImageFile(file.url || file) ? (
//                     <img
//                       src={file.url || file}
//                       alt={file.name || `Attachment ${index + 1}`}
//                       className="attachment-preview"
//                     />
//                   ) : (
//                     <span className="attachment-icon">📄</span>
//                   )}
//                   <a
//                     href={file.url || file}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="attachment-link"
//                   >
//                     {file.name || `Attachment ${index + 1}`}
//                   </a>
//                 </div>
//               ))}
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default MessageModal;



import React from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const MessageModal = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  const isImageFile = (fileName) =>
    /\.(jpg|jpeg|png|gif)$/i.test(fileName);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        bgcolor: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1300,
      }}
    >
<Box
  sx={{
    backgroundColor: "#fff",
    borderRadius: 2,
    width: "80vw",          // fixed width relative to screen
    maxWidth: 800,          // cap the max width
    minWidth: 400,
    maxHeight: "80vh",      // limit height to viewport
    display: "flex",
    flexDirection: "column",// so header stays at top
    p: 3,
    position: "relative",
    boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
  }}
>
  {/* Close button */}
<button
  onClick={onClose}
  style={{
    position: "absolute",
    // top: "8px",
    // right: "17px"
    // ,
    marginLeft:"340px",
    marginBottom:"10px",
    marginTop:0,

    color: "black",
    background: "transparent",
    border: "none",
    cursor: "pointer",
    padding: "4px",
    borderRadius: "50%",
  }}

>
  ✖
</button>


  <Typography variant="h6" sx={{ mb: 2 }}>
    Message Details
  </Typography>

  {/* Scrollable content */}
  <Box sx={{ overflowY: "auto", pr: 1, flex: 1 }}>
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Typography><strong>To:</strong> {message.receiver}</Typography>
      <Typography><strong>From:</strong> {message.sender}</Typography>
      <Typography><strong>Subject:</strong> {message.subject}</Typography>
      <Typography sx={{ whiteSpace: "pre-wrap" }}>
        <strong>Message:</strong> {message.message}
      </Typography>
      <Typography>
        <strong>Time:</strong>{" "}
        {new Date(message.createdAt).toLocaleString()}
      </Typography>
    </Box>

    {/* Attachments */}
    {message.files?.length > 0 && (
      <Box sx={{ mt: 2 }}>
        <Typography sx={{ fontWeight: 600 }}>Attachments:</Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mt: 1 }}>
          {message.files.map((file, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
                width: 100,
              }}
            >
              {isImageFile(file.url || file) ? (
                <Box
                  component="img"
                  src={file.url || file}
                  alt={file.name || `Attachment ${index + 1}`}
                  sx={{
                    width: "100%",
                    height: "auto",
                    borderRadius: 1,
                    mb: 0.5,
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                  }}
                />
              ) : (
                <Box sx={{ fontSize: 24, mb: 0.5 }}>📄</Box>
              )}
              <Typography
                component="a"
                href={file.url || file}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: "primary.main",
                  textDecoration: "none",
                  fontSize: "0.85rem",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                {file.name || `Attachment ${index + 1}`}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    )}
  </Box>
</Box>

    </Box>
  );
};

export default MessageModal;
